import { isAFunction } from "../global/utils";
import { Spending } from "../models/spending";
import ModuleController from "./ModuleController";


export default class SpendingController extends ModuleController {
    constructor(spending) {
        super();
        this.log = spending;
        this.animate = false;
        this.deleteAction = false;
    }

    // Read

    getSpending() {
        return this.log;
    }

    // Update

    setSpending(newSpending) {
        this.log = newSpending;
    }

    editSpending(newSpendingData={}) {
        this.log = new Spending(newSpendingData);
        this.subject.runReload();
    }

    // Delete

    setDeleteAction(successFn=false) {
        if ( isAFunction(successFn) ) {
            this.deleteAction = successFn;
        }
    }

    deleteSelf() {
        const id = this.log.getId();

        if ( this.deleteAction ) {
            this.deleteAction(id);
        }
    }
}